export default __webpack_public_path__ + "static/media/Stage_Circle.71e961af.png";